import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../../services/core.user.service';
import { StateService } from '@uirouter/angular';
import { ChangeEmailHelper } from './changeemail.helper';
import { GfTitleService } from '../../../../services/core.title.service';

@Component({
  selector: 'gf-changeemail-request',
  template: require('./changeemail.request.component.html')
})
export class ChangeEmailRequestComponent implements OnInit {
  user: any;
  form: UntypedFormGroup;
  msg = '';
  sending = false;
  requireCaptcha = false;
  captcha: string;
  captchaRefresh = false;
  submitting = false;

  constructor(
    private fb: UntypedFormBuilder,
    private stateService: StateService,
    private titleService: GfTitleService,
    private userService: UserService,
    private changeEmailHelper: ChangeEmailHelper
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      emailConfirm: ['', [Validators.required, Validators.email]]
    }, {
      validator: this.emailMatchValidator
    });
  }

  private emailMatchValidator(g: UntypedFormGroup) {
    return g.get('email').value === g.get('emailConfirm').value
      ? null : { 'mismatch': true };
  }

  ngOnInit(): void {
    this.titleService.setTitle('Change Email');

    if (!this.userService.hasUser()) {
      this.stateService.go('home.user.login');
      return;
    }

    this.user = this.userService.getUser();
  }

  async sendRequest(event: Event): Promise<void> {
    event.preventDefault();
    event.stopPropagation();

    if (this.form.invalid) {
      return;
    }

    this.sending = true;
    const email = this.form.get('email').value;
    const emailConfirm = this.form.get('emailConfirm').value;

    try {
      await this.changeEmailHelper.postRequest(
        email,
        emailConfirm,
        this.user.unixName,
        this.captcha
      );
      this.stateService.go('.',  
        { email: email },
        { reload: true} 
      );
    } catch (err) {
      if (err?.data?.type === 'user-registration-request-exists') {
        this.stateService.go('.', 
          { email: email },
          { reload: true }
        );
      } else {
        this.msg = err.message || 'An error occurred';
      }
    } finally {
      this.sending = false;
    }
  }
}